export const cookieName = 'floriansr_website';
